import { required, minLength } from 'vuelidate/lib/validators'

import { Component, Mixins } from 'vue-property-decorator'

import { Validation, validationMixin } from 'vuelidate'

@Component<LoginValidations>({
  validations: {
    form: {
      login: {
        required,
      },
      password: {
        required,
        minLength: minLength(8),
      },
    },
  },
})
export class LoginValidations extends Mixins<Validation>(validationMixin) {
  get loginErrors() {
    if (!this.$v.form.login.$anyDirty) return []
    const errors: Array<string> = []
    if (this.$v.form.login.$anyError) errors.push('Логин обязательное поле')
    return errors
  }

  get passwordErrors() {
    if (!this.$v.form.password.$anyDirty) return []
    const errors: Array<string> = []
    if (this.$v.form.password.$anyError) errors.push('Пароль должен содержать не менее 8 символов')
    return errors
  }
}
